<template>
  <div class="slot-picker">
    <div class="form-row">
      <div class="form-group col-md-5">
        <label :for="'sp-date-' + uid" class="sp-label">Date <span class="text-danger">*</span></label>
        <input :id="'sp-date-' + uid" v-model="date" type="date" class="form-control" :min="today" :disabled="!facilityId" />
      </div>
      <div class="form-group col-md-7 d-flex align-items-end">
        <small class="text-muted" v-if="!facilityId">Choose the telemedicine provider first.</small>
        <small class="text-muted" v-else-if="loading">Loading free times…</small>
        <small class="text-danger" v-else-if="loaded && !hasAvailability">This provider has not set its available hours yet.</small>
      </div>
    </div>

    <div v-if="facilityId && date && loaded && hasAvailability">
      <span class="sp-label d-block mb-1">Free times <span class="text-danger">*</span></span>
      <div v-if="!slots.length" class="small text-muted mb-2">No free time on this day. Try another date.</div>
      <div class="sp-grid" role="listbox" :aria-label="'Free times on ' + date">
        <button v-for="s in slots" :key="s.professional_id + '-' + s.time" type="button" role="option"
          class="sp-slot" :class="{ active: isSelected(s) }" :aria-selected="isSelected(s)" @click="choose(s)">
          <strong>{{ s.time }}</strong>
          <span v-if="!professionalId" class="sp-doc">{{ s.doctor }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Free consultation times of a telemedicine provider (or one doctor) on a day; only these can be booked.
// v-model: { date, time, professional_id, doctor } or null.
let counter = 0;

export default {
  name: "SlotPicker",
  props: {
    facilityId: { type: [Number, String], default: null },
    professionalId: { type: [Number, String], default: null },
    exceptId: { type: [Number, String], default: null }, // the consultation being moved keeps its own slot
    value: { type: Object, default: null },
    initialDate: { type: String, default: "" },
  },
  data() {
    return {
      uid: ++counter,
      date: this.initialDate || "",
      slots: [],
      hasAvailability: true,
      loading: false,
      loaded: false,
      today: new Date().toISOString().slice(0, 10),
    };
  },
  watch: {
    facilityId() { this.reload(); },
    professionalId() { this.reload(); },
    date() { this.reload(); },
  },
  created() {
    if (this.date) this.reload();
  },
  methods: {
    isSelected(s) {
      return !!this.value && this.value.date === s.date && this.value.time === s.time && Number(this.value.professional_id) === Number(s.professional_id);
    },
    choose(s) {
      this.$emit("input", { date: s.date, time: s.time, professional_id: s.professional_id, doctor: s.doctor });
    },
    reload() {
      this.$emit("input", null);
      this.slots = [];
      this.loaded = false;
      if (!this.facilityId || !this.date) return;
      this.loading = true;
      const params = { provider_id: this.facilityId, from: this.date, to: this.date };
      if (this.professionalId) params.professional_id = this.professionalId;
      if (this.exceptId) params.except_id = this.exceptId;
      this.axios
        .get("/api/v1/auth/telemedicine/slots", { params })
        .then((res) => {
          this.slots = res.data.data || [];
          this.hasAvailability = res.data.has_availability !== false;
        })
        .catch(() => { this.slots = []; })
        .finally(() => { this.loading = false; this.loaded = true; });
    },
  },
};
</script>

<style scoped>
.sp-label { font-weight: 600; font-size: .85rem; color: #374151; }
.sp-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(96px, 1fr)); gap: 8px; max-height: 220px; overflow-y: auto; padding: 2px; }
.sp-slot { border: 1.5px solid #ddd6fe; background: #fff; border-radius: 8px; padding: 6px 4px; font-size: .85rem; color: #4c1d95; line-height: 1.2; }
.sp-slot:hover { background: #f5f3ff; }
.sp-slot.active { background: #6d28d9; border-color: #6d28d9; color: #fff; }
.sp-doc { display: block; font-size: .68rem; opacity: .8; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
</style>
